import styled from "styled-components";

export const FilterItemContainerBox = styled.div<{disabled: boolean}>`
    display: flex;
    flex-direction: column;
    opacity: ${props => props.disabled ? "0.5" : "1"};
`
